import { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { CURRENCIES, fmtIDR } from "../lib/format";
import { Receipt, Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Modal } from "./OfficerHome";

const CATS = ["Bank fee", "Transfer fee", "TRON Energy", "Gas fee", "Employee", "Operational", "Other"];

export default function Expenses() {
  const [exps, setExps] = useState([]);
  const [add, setAdd] = useState(false);
  const load = () => api.get("/expenses?range=month").then((r) => setExps(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const total = exps.reduce((s, e) => s + Number(e.idr_equivalent), 0);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2"><Receipt className="h-6 w-6 text-[#EAB308]" /><h1 className="font-head text-2xl font-bold">Expenses</h1></div>
        <button className="btn-gold flex items-center gap-2" data-testid="add-expense-btn" onClick={() => setAdd(true)}><Plus className="h-4 w-4" /> Tambah</button>
      </div>

      <div className="nnx-card p-5"><div className="label">Total Expense Bulan Ini</div><div className="mono font-bold text-2xl text-rose-400 mt-1">{fmtIDR(total)}</div></div>

      <div className="nnx-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[#64748B] border-b border-[#222B3D]">
            {["Tanggal", "Kategori", "Jumlah", "IDR", "Officer", "Catatan"].map((h) => <th key={h} className="px-3 py-2.5 text-xs uppercase tracking-wider whitespace-nowrap">{h}</th>)}
          </tr></thead>
          <tbody data-testid="expense-table-body">
            {exps.length === 0 ? <tr><td colSpan={6} className="text-center py-10 text-[#64748B]">Belum ada expense</td></tr> :
              exps.map((e, i) => (
                <tr key={i} className="border-b border-[#222B3D]/60">
                  <td className="px-3 py-2.5 text-xs whitespace-nowrap">{e.biz_date}</td>
                  <td className="px-3 py-2.5">{e.category}</td>
                  <td className="px-3 py-2.5 mono text-xs">{e.amount} {e.currency}</td>
                  <td className="px-3 py-2.5 mono text-xs text-rose-400">{fmtIDR(e.idr_equivalent)}</td>
                  <td className="px-3 py-2.5 text-xs">{e.officer_name}</td>
                  <td className="px-3 py-2.5 text-xs text-[#94A3B8]">{e.note}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {add && <AddExpense onClose={() => setAdd(false)} onDone={() => { setAdd(false); load(); }} />}
    </div>
  );
}

function AddExpense({ onClose, onDone }) {
  const [f, setF] = useState({ category: "Bank fee", amount: "", currency: "IDR", idr_equivalent: "", note: "" });
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    setLoading(true);
    try { await api.post("/expenses", f); toast.success("Expense dicatat"); onDone(); }
    catch (e) { toast.error(apiError(e)); } finally { setLoading(false); }
  };
  return (
    <Modal title="Tambah Expense" onClose={onClose} testid="add-expense-modal">
      <div className="space-y-3">
        <div><label className="label">Kategori</label>
          <select data-testid="exp-category" className="nnx-input mt-1" value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })}>{CATS.map((c) => <option key={c}>{c}</option>)}</select>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div><label className="label">Jumlah</label><input data-testid="exp-amount" inputMode="decimal" className="nnx-input mono mt-1" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} /></div>
          <div><label className="label">Currency</label>
            <select data-testid="exp-currency" className="nnx-input mt-1" value={f.currency} onChange={(e) => setF({ ...f, currency: e.target.value })}>{CURRENCIES.map((c) => <option key={c.code}>{c.code}</option>)}</select>
          </div>
        </div>
        {f.currency !== "IDR" && <div><label className="label">Setara IDR</label><input data-testid="exp-idr" inputMode="decimal" className="nnx-input mono mt-1" value={f.idr_equivalent} onChange={(e) => setF({ ...f, idr_equivalent: e.target.value })} /></div>}
        <div><label className="label">Catatan</label><input data-testid="exp-note" className="nnx-input mt-1" value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} /></div>
      </div>
      <button className="btn-gold w-full mt-4" data-testid="save-expense" onClick={submit} disabled={loading}>{loading ? <Loader2 className="h-4 w-4 animate-spin inline" /> : "SIMPAN"}</button>
    </Modal>
  );
}
